<template>
  <v-form>
    <app-title>Review Clawbacks</app-title>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <v-text-field
              single-line
              type="number"
              label="Runs"
              v-model="runs"
              hint="Enter oldest RunID to check clawbacks"
              @change="collectClawBacks"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>

        <v-spacer></v-spacer>
      </v-card-title>
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-balham"
        :columnDefs="headers"
        :rowData="clawbacks"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        rowSelection="multiple"
        :supressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
        ref="grid"
        enableCellTextSelection
      ></ag-grid-vue>
    </v-card>

    <div class="text-right pt-2">
      <v-spacer></v-spacer>
      <v-btn color="primary" class="mr-2" @click="setClawBacks"
        >Set Clawbacks</v-btn
      >
    </div>
  </v-form>
</template>
<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridVue } from "ag-grid-vue";
import { mapActions } from "vuex";
export default {
  name: "ViewClawbacks",
  components: {
    AgGridVue,
  },
  data() {
    return {
      gridOptions: {},
      defaultColDef: { resizeable: true, sortable: true },
      runs: 400,
      loading: false,
      search: "",
      currentRow: undefined,
      clawbacks: [],
      headers: [
        {
          headerName: "Dealer",
          field: "dealerID",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          checkboxSelection: true,
        },
        {
          headerName: "Customer Number",
          field: "custNo",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "CSN",
          field: "csn",
          sortable: true,
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Rate Plan",
          field: "ratePlanDescription",
          sortable: true,
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Date Added",
          field: "serviceDateAdded",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Date Disconnected",
          field: "dateDisconnected",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Run Paid",
          field: "runIDPaid",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
        {
          headerName: "Date Paid",
          field: "datePaid",
          sortable: true,
          filter: "agDateColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: "Amount Paid",
          field: "amount",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          valueFormatter: this.currencyFormatter,
        },
        {
          headerName: "Months Diff",
          field: "monthsDiff",
          sortable: true,
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
        },
      ],
    };
  },
  methods: {
    ...mapActions("clawBacks", ["getClawBacks", "commitClawBacks"]),
    collectClawBacks() {
      let vm = this;
      vm.gridOptions.api.showLoadingOverlay();
      vm.getClawBacks(vm.runs)
        .then((result) => {
          vm.clawbacks = result;
          vm.gridOptions.api.hideOverlay();
        })
        .catch(() => {
          vm.gridOptions.api.hideOverlay();
        });
    },
    setClawBacks() {
      let vm = this;
      let selected = vm.gridOptions.api.getSelectedRows();
      vm.commitClawBacks(selected).then((result) => {
        vm.clawbacks = result;
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
  },
  mounted() {
    this.collectClawBacks();
  },
};
</script>
